import axios, { AxiosError } from 'axios';
import type { AxiosRequestHeaders, AxiosRequestConfig, AxiosResponse } from 'axios';

const httpClient = axios.create({
  baseURL: window.appConfig.endpoints.url,
  retired: false,
} as AxiosRequestConfig);

httpClient.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    const headers: Record<string, string> = {
      // api_key: window.appConfig.endpoints.apiKey,
      // access_token: window.appConfig.endpoints.accessToken,
    };
    return {
      ...config,
      headers: headers as unknown as AxiosRequestHeaders,
    };
  },
  (err: AxiosError) => {
    return Promise.reject(err);
  }
);

httpClient.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  async (err: AxiosError) => {
    // eslint-disable-next-line
    console.warn('could not recover failed api call');
    return Promise.reject(err);
  }
);

export { httpClient };
export default {
  // eslint-disable-next-line
  install: (Vue: any) => {
    Vue.prototype.$httpClient = httpClient;
  },
};
